<template>
  <div class="ad-tab">
    <ul>
      <li @click="clickHandler(0)" :class="{active:active==0}">体系一</li>
      <li @click="clickHandler(1)" :class="{active:active==1}">体系二</li>
      <li @click="clickHandler(2)" :class="{active:active==2}">体系三</li>
    </ul>
    <div class="content">
      <img :class="{active:active==0}" src="/images/goods/pkg1.png" alt="">
      <img :class="{active:active==1}" src="/images/goods/pkg2.png" alt="">
      <img :class="{active:active==2}" src="/images/goods/pkg3.png" alt="">
    </div>
    <div class="content sp">
      <img class="active" src="/images/goods/pkg4.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0
    };
  },
  methods: {
    clickHandler(index) {
      this.active = index;
    }
  }
};
</script>
<style scoped>
.ad-tab {
  background: #fff1e2;
  padding: 20px 0 36px;
}
.ad-tab > * {
  margin: 0 auto;
}
.ad-tab ul {
  width: 333px;
  display: flex;
  align-items: flex-end;
  height: 42px;
}
.ad-tab ul li {
  width: 111px;
  height: 30px;
  line-height: 30px;
  background: rgba(252, 129, 95, 0.7);
  transition: all 0.1s ease-out;
  color: #fff;
  text-align: center;
  border-radius: 6px 6px 0px 0px;
  font-size: 14px;
}
.ad-tab ul li.active {
  height: 42px;
  line-height: 42px;
  background: #fc815f;
}
.content {
  width: 333px;
  height: 210px;
  background: rgba(252, 129, 95, 1);
  position: relative;
  border-radius: 0px 0px 6px 6px;
}
.content > img {
  display: block;
  width: 300px;
  position: absolute;
  left: 0;
  top: 18px;
  opacity: 0;
  transition: all 0.3s ease-out;
}
.content.sp {
  border-radius: 6px;
  height: 152px;
  margin-top: 17px;
}
.content > img.active {
  opacity: 1;
  left: 17px;
}
</style>